<template>
	<div class="security">
		<div class="title">支付密码设置</div>
		<div class="input-box">
			<div class="title">旧密码：</div>
			<input placeholder="请输入旧密码，首次设置可放空" type="password" v-model="info.raw_password" />
		</div>
		<div class="input-box">
			<div class="title">新密码：</div>
			<input placeholder="请输入新密码" type="password" v-model="info.new_password" />
		</div>
		<div class="input-box">
			<div class="title">确认密码：</div>
			<input placeholder="请再次输入确认密码" type="password" v-model="info.confirm_password" />
		</div>
		<button class="save" @click="save">确认</button>

	</div>
</template>

<script>
	import {profile, revisePayPassword} from "@/api"
	export default {
		name: 'PayPassword',
		data() {
			return {
				info:{
					raw_password: "",
					new_password: "",
					confirm_password: ""
				}
			};
		},
		methods: {
			save(){
				revisePayPassword(this.info).then((res)=>{
					this.$Notice.success({
						title: '修改成功',
					});
					return profile()
				}).then((response) => {
					this.$store.commit('setUserInfo', response.data)
				}).then(() => {
					if(this.$route.params.redirect) this.$router.replace({path: this.$route.params.redirect})
				}).catch(err => {
					this.$Notice.error({
						title: err.msg,
					});
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.security{
		width: 950px;
		height: 460px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;
		.title{
			font-size: 20px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
			margin-bottom: 20px;
		}

		.input-box{
			height: 40px;
			margin-bottom: 30px;
			display: flex;
			.title{
				width: 86px;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				font-weight: 400;
				color: #333333;
			}
			input{
				width: 224px;
				height: 40px;
				line-height: 40px;
				background: #FFFFFF;
				border: 1px solid #DDDDDD;
				padding-left: 20px;
				color: #333333;
			}
		}
		.save{
			width: 100px;
			height: 40px;
			line-height: 40px;
			background: #0F114A;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 86px;
			padding-bottom: 30px;
		}
	}
</style>
